module.exports = __webpack_public_path__ + "assets/media/lunch.628b89e2.mp3";